import gql from 'graphql-tag';
export const getAllSurveyDistributionResultsQuery = gql`
  query getAllSurveyDistributionResults {
    allSurveyDistributionResults {
      surveyId
      questionId
      customer
      artikalId
      prisutan
      komentar
      remoteLocation
      locationLat
      locationLon
      photoFilenames
    }
  }
`;